import {type RightNavTopic} from './types';

export const POPULAR_TOPICS_CONFIG: RightNavTopic[] = [
  {
    name: 'AI agent observability',
    items: [
      {
        name: 'Evaluations',
        link: 'https://wandb.ai/fully-connected/blog/evaluations',
      },
      {
        name: 'Agent building and monitoring',
        link: 'https://wandb.ai/fully-connected/blog/agents',
      },
      {
        name: 'Inference',
        link: 'https://wandb.ai/fully-connected/blog/inference',
      },
      {
        name: 'Safety and scoring',
        link: 'https://wandb.ai/fully-connected/blog/safety-scoring',
      },
    ],
  },
  {
    name: 'Build models',
    items: [
      {
        name: 'Computer vision',
        link: 'https://wandb.ai/fully-connected/blog/computer-vision',
      },
      {
        name: 'Building LLMs',
        link: 'https://wandb.ai/fully-connected/blog/llm',
      },
      {name: 'NLP', link: 'https://wandb.ai/fully-connected/blog/nlp'},
      {
        name: 'Model ops',
        link: 'https://wandb.ai/fully-connected/blog/model-ops',
      },
    ],
  },
  {
    name: 'About Weights & Biases',
    items: [
      {
        name: 'Product announcements',
        link: 'https://wandb.ai/fully-connected/blog/feature-releases',
      },
      {
        name: 'Integrations',
        link: 'https://wandb.ai/fully-connected/blog/framework-integration',
      },
      {name: 'Events', link: 'https://wandb.ai/site/resources/events/'},
      {name: 'Podcast', link: 'https://wandb.ai/site/resources/podcast/'},
    ],
  },
];
